import { Form, Input, Button, Col } from 'antd'
import { useTranslation } from 'react-i18next'

export function LoginForm({ onForgotPassword, onSubmit }) {
  const { t } = useTranslation()

  return (
    <Form layout="vertical" onFinish={onSubmit} requiredMark={false}>
      <Form.Item
        label={t('Login.ExistingEmail')}
        name="email"
        htmlFor="login-email"
        rules={[
          {
            required: true,
            message: t('Login.error.PleaseEnterEmail'),
          },
          {
            type: 'email',
            message: t('Register.error.PleaseEnterValidEmail'),
          },
        ]}
      >
        <Input id="login-email" autoComplete="username" placeholder="" />
      </Form.Item>
      <Form.Item>
        <Button
          className="login-form-forgot"
          type="link"
          onClick={onForgotPassword}
        >
          {t('Login.ForgotPassword')}
        </Button>
      </Form.Item>
      <Form.Item
        label={t('Login.ExistingPassword')}
        htmlFor="login-password"
        name="password"
        rules={[
          {
            required: true,
            message: t('Login.error.PleaseEnterPassword'),
          },
        ]}
      >
        <Input.Password
          id="login-password"
          autoComplete="current-password"
          placeholder=""
        />
      </Form.Item>
      <Form.Item>
        <Col xs={24} sm={14} xl={12}>
          <Button type="primary" htmlType="submit" block>
            {t('Login.Login')}
          </Button>
        </Col>
      </Form.Item>
    </Form>
  )
}
export default LoginForm
